@if (isImpersonating$ | async) {
  @let user = (user$ | async);
  <div class="fixed top-0 left-0 right-0 z-[1000] bg-warning text-warning-content flex items-center justify-between px-4 py-2 shadow-md">
    <div class="flex items-center gap-2 text-sm font-medium">
      <i class="fa-solid fa-user-secret"></i>
      <span>
        Admin Access — Viewing as
        <strong>{{ getUserDisplayName(user) }}</strong>
        ({{ user?.role }})
      </span>
    </div>
    <button
      class="daisy-btn daisy-btn-sm daisy-btn-error gap-1"
      (click)="endImpersonation()"
    >
      <i class="fa-solid fa-arrow-right-from-bracket"></i>
      End Impersonation
    </button>
  </div>
  <!-- Spacer to prevent content from hiding behind the fixed banner -->
  <div class="h-12"></div>
}
